<template>
    <div>
        <h1 style="font-size: 24px; color: black;">游戏评分配置 </h1>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="5" style="margin-left:10px;" >
                    <el-button  type="primary" @click="handleEdit(0,null)">新增游戏</el-button>
                </el-col>
            </el-row>
        </el-card>
        <div>
            <el-table
                border
                :fit="true"
                :data="strategys">
                <el-table-column prop="id" label="id"></el-table-column>
                <el-table-column prop="name" label="规则组名称"></el-table-column>
                <el-table-column prop="subChannel" label="渠道名称"></el-table-column>
                <el-table-column label="操作" align="center" width="300px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(1,scope.row)">编辑</el-button>
                        <el-button size="mini" type="info" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-dialog :title="editDialogTitle"
                       center
                       :visible.sync="editDialogVisible"
                       @close="editDialogVisible=false"
                       width="1500px">
                <el-row >
                    <el-col :span="12">
                        <el-form :model="plateEditForm">
                            <el-form-item label="规则名称" :label-width="labelWidth">
                                <el-input style="width: 220px" type="text" maxlength="8" placeholder="不超过8个字符" v-model="plateEditForm.name"></el-input>
                            </el-form-item>
                            <el-form-item label="渠道选择" :label-width="labelWidth">
                                <el-cascader  v-model="plateEditForm.subChannelTemp" :options="channelList" :props="optionProps" clearable collapse-tags placeholder="请选择" >
                                </el-cascader>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row  >
                    <el-table border
                              :data="plateEditForm.rulePojoList"
                              tooltip-effect="dark"
                              :row-class-name="markRowIndex"
                              element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.5)"
                            v-loading="loading"
                              style="width: 100%">
                        <el-table-column
                                prop="score"
                                label="分值"
                                width="50">
                        </el-table-column>
                        <el-table-column :label = "item" v-for = "(item,index1) in paramsName" width="250px"  :key = "index1">
                            <template slot-scope = "scope">
                                <el-input-number controls-position="right" style="width: 100px" v-model = "scope.row.ruleList[index1].min"></el-input-number>
                                -
                                <el-input-number controls-position="right" style="width: 100px" v-model = "scope.row.ruleList[index1].max"></el-input-number>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row  >
                    <el-table border
                              :data="plateEditForm.tempWeight"
                              tooltip-effect="dark"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.5)"
                            v-loading="loading"
                              style="width: 100%">
                        <el-table-column :label = "item" v-for = "(item,index2) in paramsName" width="250px"  :key = "index2">
                            <template slot-scope = "scope">
                                <el-input-number controls-position="right" style="width: 100px" v-model = "scope.row[index2].rate"></el-input-number>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row  >
                        <div style="text-align: center;">
                                <el-button type="primary" @click="confirmEditFormDialog">确 定</el-button>
                                <el-button type="info" @click="editDialogVisible=false">取 消</el-button>
                        </div>
                </el-row>
            </el-dialog>
        </div>
    </div>

</template>


<script>
import {
    channelList
} from "@/http/api";
import {
    allStrategy,
    ruleDetail,
    ruleSave ,
    ruleDel
} from "@/http/recommendApi";
    export default {
        name: "MarkConfig",
        inject: ['reload'],
        data(){
            return{
                channelList:[],
                subChannelList:[],
                subChannels:[],
                strategys:[],
                optionProps: {
                    emitPath:false,
                    multiple:true,
                    value:'subChannel',
                    label: 'name',
                    children: 'children',
                },
                plateEditForm : {
                    "strategyId": null,
                    "name": "",
                    "subChannel":null,
                    "subChannelTemp":null,
                    "rulePojoList":[],
                    "weightList":[],
                },
                paramsName: ['新增(人)', '留存(%)','游戏人均时长(分钟)','人均游戏频次(次)','人均广告视频次数(次)','LTV','ARPU','7日LTV','人均广告次数'],
                // paramsName: ['新增(人)', '留存(%)','游戏人均时长(分钟)','人均游戏频次(次)','人均广告视频次数(次)'],
                editDialogTitle:null,
                editDialogVisible:false,
                labelWidth:"80px",
                loading:false,
            }
        },
        methods:{
            markRowIndex ({row, rowIndex}) {
                // 把每一行的索引放进row
                row.index = rowIndex;
            },
            handleEdit: function (type,row) {
            this.loading = true;
            setTimeout(() => {
                    this.loading = false;
                },2000);
            // console.log(this.channelList)
            if(type===0){
                this.plateEditForm = {
                    "strategyId": null,
                    "name": "",
                    "subChannel":null,
                    "subChannelTemp":null,
                    "rulePojoList":[
                    {"score":1,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":2,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":3,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":4,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":5,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":6,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":7,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":8,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":9,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    {"score":10,"ruleList":[{"dimensionId":1,"min":0,"max":0},{"dimensionId":2,"min":0,"max":0},{"dimensionId":3,"min":0,"max":0},{"dimensionId":4,"min":0,"max":0},{"dimensionId":5,"min":0,"max":0},{"dimensionId":6,"min":0,"max":0},{"dimensionId":7,"min":0,"max":0},{"dimensionId":8,"min":0,"max":0},{"dimensionId":9,"min":0,"max":0}]},
                    ],
                    "weightList":[{"dimensionId":1,"rate":0},{"dimensionId":2,"rate":0},{"dimensionId":3,"rate":0},{"dimensionId":4,"rate":0},{"dimensionId":5,"rate":0},{"dimensionId":6,"rate":0},{"dimensionId":7,"rate":0},{"dimensionId":8,"rate":0},{"dimensionId":9,"rate":0}],
                    "tempWeight":[],
            };
                this.plateEditForm.tempWeight.push(this.plateEditForm.weightList);
                this.editDialogTitle = "新增";
                this.editDialogVisible = true;
            }
            if (type===1) {
                this.editDialogTitle = "编辑";
                this.editDialogVisible = true;
                    ruleDetail(row.id).then(resp => {
                    //处理返回数据
                    // console.log(resp.data.info)
                    var pojo= resp.data.info;
                    this.plateEditForm = {
                        "strategyId": row.id,
                        "name": row.name,
                        "subChannel":row.subChannel,
                        "subChannelTemp":row.subChannel.split(','),
                        "rulePojoList":pojo.rulePojoList,
                        "weightList":pojo.weightList,
                        "tempWeight":[],
                    };
                    this.plateEditForm.tempWeight.push(pojo.weightList);
                    })
            }
        },
        confirmEditFormDialog(){
            this.plateEditForm.subChannel=this.plateEditForm.subChannelTemp.join(',');
            this.plateEditForm.weightList=this.plateEditForm.tempWeight[0];
            ruleSave(this.plateEditForm).then(resp =>{
                if(resp.data.status===0){
                    // console.log(resp.data);
                    this.strategys=resp.data.info;
                }
            })
            this.editDialogVisible=false ;
        },
        handleDelete(row){
            this.$confirm('确认是否删除?', '警告', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    ruleDel(row.id).then(resp=>{
                        if(resp.data.status===0){
                            this.reload();
                        }
                    })
                }).catch(()=>{
                })
        }
        },
        created() {
            channelList().then(resp=>{
                    let _this = this;
                    this.channelList=JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                        if (channel.children) {
                            channel.children = channel.children.filter(sub => sub.state === 1)
                        }
                        return channel;
                    }).filter(channel => channel.children && channel.children.length);
                    this.channelList.forEach(function (channel) {
                        _this.$set(channel,'subChannel',channel.id);
                        channel.children.forEach(function (sub) {
                            _this.subChannelList.push(sub);
                            _this.subChannels.push(sub.subChannel);
                        })
                    })
                });
        allStrategy().then(
            resp => {
                this.strategys=resp.data.info;
            }
        )
        },
    }
</script>

<style scoped>

</style>
